export default __webpack_public_path__ + "static/media/slack.f0b7bd6e.svg";